/**
 * App name definitions
 * Maps internal code names to customer-facing names
 */

export type AppType = 'viewer' | 'studio' | 'admin';

export interface AppName {
  /** Internal code name (used in code, Firebase projects, etc.) */
  codeName: AppType;
  /** Customer-facing display name */
  displayName: string;
  /** Full customer-facing name with brand */
  fullName: string;
}

/**
 * App name mappings
 */
export const APP_NAMES: Record<AppType, AppName> = {
  viewer: {
    codeName: 'viewer',
    displayName: 'Context Viewer',
    fullName: 'up.forsale — Context Viewer'
  },
  studio: {
    codeName: 'studio',
    displayName: 'Agent Studio',
    fullName: 'up.forsale — Agent Studio'
  },
  admin: {
    codeName: 'admin',
    displayName: 'Control Panel',
    fullName: 'up.forsale — Control Panel'
  }
};

/**
 * Get app name information by code name
 */
export function getAppName(codeName: AppType): AppName {
  return APP_NAMES[codeName];
}

/**
 * Get display name by code name
 */
export function getAppDisplayName(codeName: AppType): string {
  return APP_NAMES[codeName].displayName;
}

/**
 * Get full name by code name
 */
export function getAppFullName(codeName: AppType): string {
  return APP_NAMES[codeName].fullName;
}

